import { Box } from '@mui/material';
import { FormTitleBox } from '../../common/components';
import ConsumptionsDataTable from './components/ConsumptionsDataTable';
import ConsumptionsPagination from './components/ConsumptionsPagination';
import ConsumptionDetailDialog from './components/ConsumptionDetailDialog';
import { useConsumptionsTable } from './hooks/useConsumptionsTable';

const ConsumptionsTable = () => {
  const {
    data,
    isLoading,
    totalPages,
    totalCount,
    page,
    rowsPerPage,
    searchTerm,
    detailDialogOpen,
    selectedConsumptionId,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleViewDetail,
    handleCloseDetailDialog,
    handleRefreshList,
  } = useConsumptionsTable();

  return (
    <Box>
      <FormTitleBox
        title="Stock y compras | Consumos de stock"
        showSearch
        searchLabel="Buscar consumo"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      <ConsumptionsDataTable
        data={data}
        isLoading={isLoading}
        onView={handleViewDetail}
      />

      {totalPages > 1 && (
        <ConsumptionsPagination
          totalPages={totalPages}
          totalCount={totalCount}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}

      <ConsumptionDetailDialog
        open={detailDialogOpen}
        onClose={handleCloseDetailDialog}
        consumptionId={selectedConsumptionId}
        onRefreshList={handleRefreshList}
      />
    </Box>
  );
};

export default ConsumptionsTable;
